import { render } from "./uiImgRotable.vue?vue&type=template&id=3b17c46c"
import script from "./uiImgRotable.vue?vue&type=script&lang=js"
export * from "./uiImgRotable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__